
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[podcastSeason]/[podcastEpisode]",
      function () {
        return require("private-next-pages/podcast/[podcastSeason]/[podcastEpisode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/[podcastSeason]/[podcastEpisode]"])
      });
    }
  